@let s = score();
@if (s > 0) {
  <img class="image" src="{{ rating().path }}" alt="{{ rating().label }}" />
  <div>{{ rating().label }}</div>
  <div class="score">
    <span i18n>(Avg. score {{ rating().score }})</span>
    <app-info-hover>
      <p i18n>
        Answers to the question "How likely are you to use a solution like this if it were available?" are converted to
        numbers to calculate an average.
        <br />
        In the summary, smileys represent the averages categorized into the following intervals:
      </p>
      <ul>
        <li><app-rating-icon [rating]="0" /> <span i18n>Very unlikely = 0 - 1.25</span></li>
        <li><app-rating-icon [rating]="2.5" /> <span i18n>Somewhat unlikely = 1.26 - 3.75</span></li>
        <li><app-rating-icon [rating]="5" /> <span i18n>Neutral = 3.76 - 6.25</span></li>
        <li><app-rating-icon [rating]="7.5" /> <span i18n>Somewhat likely = 6.26 - 8.75</span></li>
        <li><app-rating-icon [rating]="10" /> <span i18n>Very likely = 8.76 - 10</span></li>
      </ul>
    </app-info-hover>
  </div>
}
